var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThunderstormNightIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.313,
    height: 24.433,
    viewBox: "0 0 24.313 24.433",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "thunderstorm-night-icon",
    transform: "translate(29.313 -57.954)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Area",
    width: 24,
    height: 24,
    transform: "translate(-29 58)",
    fill: "rgba(252,252,252,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M-10.255,74.9c3.822-.776,5.734-5.721,1.959-9.135A3.067,3.067,0,0,0-10.354,65h-2.161c-1.461-5.658-8.624-8.332-13.748-3.461a4.34,4.34,0,0,0-.79,1.014,8.183,8.183,0,0,0-.983,6.346,8.183,8.183,0,0,0,3.9,5.1",
    fill: "none",
    stroke: "#364456",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    d: "M-16.254,69l-4,6h6l-4,6",
    fill: "none",
    stroke: "#ffb100",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunderstormNightIcon);
export default __webpack_public_path__ + "static/media/thunderstorm-night-icon.f3503203586cda78539b422d9ca1bde2.svg";
export { ForwardRef as ReactComponent };